/**
 * Maps environment and deployment cluster to the bucket path segment
 *
 * NOTE: This is necessary for historical reasons, and will be removed after https://empiriecom.atlassian.net/browse/SEARCH-3647
 */
export const getNavigationBucketPath = (env: string): string => {
  const envMap: Record<string, string> = {
    staging: 'dev',
    production: 'cloud',
    prod: 'cloud', // legacy support for 'prod' as an alias for 'production'
  };

  return envMap[env] || 'dev';
};
